<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!-- 列表区 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['cont:putcontract:list']" @load="onLoad" v-if="list.length > 0">
      <list-item @todetail="toCustOrderDetails" :listData="list" />
    </van-list>
    <!-- 缺省页 -->
    <empty-component v-if="isEmpty" />
    <!--客户搜索筛选框-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <!-- picker -->
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
import { listOrder } from "@/api/cont/putcontract";
import { getDicts } from "@/api/system/dict/data";
import { getProvinceCityList } from "@/api/system/area";
import { getTwoLevelIndustryList } from "@/api/system/qqAdIndustry";
import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { areaList } from "@vant/area-data";
import SearchComponent from "@/components/common/Search";
import EmptyComponent from "@/components/common/Empty";
import ListItem from "../components/custsale/ListItem.vue"
import SearchPop from '../components/custsale/SearchPop.vue';
export default {
  components: {
    SearchComponent,
    EmptyComponent,
    ListItem,
    SearchPop
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      isEmpty: false,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
        areaList,
      },
      loading: false,
      finished: false,
      showFilterPop: false,
      list: [],
      type: "add",
      show: false,
      searchParams: {
        visible: false,
      },
      searchValue: "",
      custList: [],
      // 客户意向等级
      custLevelOptions: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      form: {
        custId: null,
        custLevelId: null,
        custName: null,
        clueId: null,
        custSource: null,
        custType: null,
        clueStatus: null,
        clueLabel: null,
        industryCode: null,
        industryName: null,
        businessTypeId: null,
        businessTypeName: null,
        areaId: null,
        areaName: null,
        custStatus: "8",
        scale: null,
        mainProducts: null,


        custAddress: null,
        custLogo: null,

        openId: null,
        distance: null,
        longitude: null,
        latitude: null,
        distributionUserid: null,
        distributionUserName: null,
        distributionTime: null,
        lastFollowTime: null,
        lastFollowContent: null,
     //   turnOpportunityTime: null,
        myUserid: null,
     //   followUserid: null,
      //  followUserName: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        orderNum: null,
        remark: null,
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        custLevelId: null,
        custName: null,
        clueId: null,
        custSource: null,
        custType: null,
        clueLabel: null,
        industryCode: null,
        industryName: null,
        businessTypeId: null,
        businessTypeName: null,
        areaId: null,
        areaName: null,
        custStatus: "8", //
        scale: null,
        mainProducts: null,


        custAddress: null,
        custLogo: null,

        openId: null,
        distance: null,
        longitude: null,
        latitude: null,
        distributionUserid: null,
        distributionUserName: null,
        distributionTime: null,
        lastFollowTime: null,
        lastFollowContent: null,
        turnOpportunityTime: null,
        myUserid: null,
        followUserid: null,
        followUserName: null,
        status: null,
        orderNum: null,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "CONT-未上传合同";
      this.getCustLevelList();
      // 获取地区（省、市）
      getProvinceCityList().then((response) => {
        this.areaOptions = this.handleTree(response.data, "areaId");
      });
      // 获取行业（前2级）
      getTwoLevelIndustryList().then((response) => {
        this.industryOptions = this.handleTree(
          response.data,
          "systemIndustryId"
        );
      });
      await this.handleList();
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.resetQuery()
      this.queryParams.custName = this.searchValue = data;
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      let query = this.queryParams;
      this.queryParams = { ...query, ...data }
      this.queryCustList()
    },
    queryCustList() {
      this.list = [];
      this.queryParams.pageNum = 1
      this.handleList();
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toCustOrderDetails(item) {
      this.$router.push({
        name: "putcontractDetail",
        params: {
          id: item.custSaleId,
          isPut: true
        },
      });
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "custLevelId") {
        this.picker.columns = this.custLevelOptions.map((ele) => ele.levelName);
      }
      if (type === "custSource") {
        this.picker.columns = this.custSourceOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "custType") {
        this.picker.columns = this.custTypeOptions.map((ele) => ele.dictLabel);
      }
      if (type === "industryCode") {
        this.picker.columns = this.industryOptions.map((ele) =>
          this.industryNormalizer(ele)
        );
      }
      if (type === "areaId") {
        this.picker.columns = this.areaOptions.map((ele) =>
          this.areaNormalizer(ele)
        );
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "custLevelId") {
        this.form.custLevelId = this.custLevelOptions[index].custLevelId;
        this.form.custLevelName = this.custLevelOptions[index].levelName;
      }
      if (this.picker.formKey === "custSource") {
        this.form.custSource = this.custSourceOptions[index].dictValue;
        this.form.custSourceName = this.custSourceOptions[index].dictLabel;
      }
      if (this.picker.formKey === "custType") {
        this.form.custType = this.custTypeOptions[index].dictValue;
        this.form.custTypeName = this.custTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "industryCode") {
        if (value.length == 2) {
          if (value[1].length > 0) {
            let obj = this.industryOptions.find(
              (item) => item.industryName === value[0]
            );
            if (obj != null) {
              this.form.industryCode = obj.children.find(
                (item) => item.industryName === value[1]
              ).systemIndustryId;
            }
            this.form.industryName = value[0] + "/" + value[1];
          }
        } else {
          this.form.industryName = value[0];
          let obj = this.industryOptions.find(
            (item) => item.industryName === value[0]
          );
          if (obj != null) {
            this.form.industryCode = obj.systemIndustryId;
          }
        }
      }
      if (this.picker.formKey === "areaId") {
        if (value.length == 2) {
          if (value[1].length > 0) {
            let obj = this.areaOptions.find(
              (item) => item.areaName === value[0]
            );
            if (obj != null) {
              this.form.areaId = obj.children.find(
                (item) => item.areaName === value[1]
              ).areaId;
            }
            this.form.areaName = value[0] + "/" + value[1];
          }
        } else {
          this.form.areaName = value[0];
          let obj = this.areaOptions.find((item) => item.areaName === value[0]);
          if (obj != null) {
            this.form.areaId = obj.areaId;
          }
        }
      }
      this.picker.visible = false;
    },
    /** 转换行业数据结构 */
    industryNormalizer(node) {
      let arr = [];
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].systemIndustryId,
            text: node.children[i].industryName,
          };
          arr.push(item);
        }
      }

      return {
        id: node.systemIndustryId,
        text: node.industryName,
        children: arr,
      };
    },

    /** 转换地区数据结构 */
    areaNormalizer(node) {
      let arr = [];
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName,
          };
          arr.push(item);
        }
      }

      return {
        id: node.areaId,
        text: node.areaName,
        children: arr,
      };
    },
    // /** 转换地区数据结构 */
    // areaNormalizer1(node) {
    //   let arr = []
    //   let threeArr = []
    //   if (node.children && node.children.length) {
    //     for(let i in node.children){
    //       console.log(node.children[i].children[0])
    //       if(node.children[i].children && node.children[i].children.length ){
    //         for(let j in node.children[i].children){
    //           console.log(node.children[i].children[j])
    //           let threeItem ={
    //             id : node.children[i].children[j].areaId,
    //             text: node.children[i].children[j].areaName
    //           }
    //           threeArr.push(threeItem)
    //         }
    //       }else{
    //         delete node.children[i].children
    //       }
    //       let item ={
    //         id : node.children[i].areaId,
    //         text: node.children[i].areaName,
    //         children: threeArr
    //       }
    //       arr.push(item)
    //     }
    //   }
    //   return {
    //     id: node.areaId,
    //     text: node.areaName,
    //     children: arr
    //   };
    // },
    areaConfirm(values) {
      this.form.areaId = values[values.length - 1].code;
      this.form.areaName = values[values.length - 1].name;
      this.picker.visible = false;
    },
    pickerCancel() {
      this.picker.visible = false;
    },
    pickerChange() { },
    update(type, row) {
      this.reset();
      this.type = type;
      this.show = true;
      if (row) {
      }
    },
    async handleList() {
      this.loading = true;
      const res = await listOrder(this.queryParams);
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.list = this.list.concat(res.rows);
        this.queryParams.pageNum += 1;
        this.loading = false;
        this.finished = this.list.length >= res.total;
        this.showFilterPop = false
      }
    },
    onLoad() {
      this.handleList();
    },

    //获取用户等级
    getCustLevelList() {
      selectAllCustLevel(null).then((response) => {
        this.custLevelOptions = response.data;
      });
    },
    resetQuery() {
      // 查询参数
      this.queryParams= {
        pageNum: 1,
        pageSize: 10,
        custLevelId: null,
        custName: null,
        custSource: null,
        custType: null,
        clueLabel: null,
        businessTypeId: null,
        businessTypeName: null,
        industryCode: null,
        industryName: null,
        areaId: null,
        areaName: null,
        scale: null,
        mainProducts: null,
        custAddress: null,
        custLogo: null,
        openId: null,
        distance: null,
        longitude: null,
        latitude: null,
        distributionUserid: null,
        distributionUserName: null,
        distributionTime: null,
        lastFollowTime: null,
        lastFollowContent: null,
        myUserid: null,
        status: null,
        orderNum: null,
      }
    },
    reset() {
      this.form = {
        custId: null,
        custLevelId: null,
        custName: null,
        custSource: null,
        custType: null,
        clueLabel: null,
        industryCode: null,
        industryName: null,
        businessTypeId: null,
        businessTypeName: null,
        areaId: null,
        areaName: null,
        releaseMode: null,
        custStatus: "0",
        scale: null,
        mainProducts: null,
        custAddress: null,
        custLogo: null,
        openId: null,
        distance: null,
        longitude: null,
        latitude: null,
        distributionUserid: null,
        distributionUserName: null,
        distributionTime: null,
        lastFollowTime: null,
        lastFollowContent: null,
        turnOpportunityTime: null,
        myUserid: null,
        followUserid: null,
        followUserName: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        orderNum: null,
        remark: null,
      };
    },
    contactFormReset() {
      this.contactForm = {
        contactId: null,
        contactName: null,
        custId: null,
        custName: null,
        sex: null,
        mobile: null,
        qq: null,
        email: null,
        weixinSn: null,
        deptName: null,
        jobs: null,
        age: null,
        birthday: null,
        ideType: null,
        ideTypeName: null,
        ideSn: null,
        jobTitle: null,
        nickName: null,
        roleRelation: null,
        roleRelationName: null,
        intimacy: null,
        intimacyName: null,
        hobby: null,
        myUserid: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        orderNum: null,
        remark: null,
      };
    },

    visitFormReset() {
      this.visitForm = {
        content: null,
        visitType: null,
        custId: null,
        custName: null,
        contactId: null,
        contactName: null,
      };
    },
  },
};
</script>


<style scoped lang='less'>
@import url("@/style/index.less");

.type-list {
  padding: 10px;
  .title {
    font-size: 40px;
    margin-bottom: 20px;
  }
  .list-wrapper {
    display: flex;
    flex-wrap: wrap;
    button {
      margin: 10px;
    }
  }
}
.arrow-color {
  color: #eee;
}
</style>
<style>
</style>